import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { BookingService } from "../../booking/service/booking.service";
import { ServicePaymentService } from "../service/servicepayment.service";
import { UserData, PaymentDetails, PaytabsPaymentDetails, PaymentHistory, ServicePaykeyvaluepair, PaymentDetailsDataContainer, GeneralBookingModel, requestParam, responseParam } from "../../model/index";
import { AdvancePaymentService } from "../../advancepayment/service/advancepayment.service";
declare var bookingGrid: any;
declare var require: any;
declare let jspdf: any;
declare let html2canvas: any;
declare let MaxWallet: any;
declare let CryptoJS: any;
declare let Checkout: any;
@Component({
    selector: 'MentisSoft-Allergy',
    template: require('../Template/ServicePayment.template.html'),
    providers: [ServicePaymentService, AdvancePaymentService]
})

export class ServicePaymentComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("PopupPayment") PopupPayment: ModalComponent;
    loading = false;
    redirectString: string;
    Querynumber: string;
    paymentDetails: PaymentDetails[] = [];
    temp: number = 0;
    totalGrossAmount: number = 0;
    totalGrossAmountString: string = "";
    totalAdjustedAmount: number = 0;
    totalPatientPartAmount: number = 0;
    dataSource: PaymentHistory[] = [];
    paymentServicesForPaytabs: PaymentDetails[] = [];
    paytabsPaymentDetails: PaytabsPaymentDetails = new PaytabsPaymentDetails();
    paymentDetailsbefore: PaymentDetails[] = [];
    paymentDetailsafter: PaymentDetails[] = [];
    isValid: boolean = false;
    tempString: string;
    CurrencyValue: string;
    EnableAmountAdjustColumn: boolean = false;
    adjustedAmountCalc: number = 0;
    IsAmountAdjusted: boolean = false;
    items: { [index: string]: number } = {};
    dictValues: ServicePaykeyvaluepair[] = [];
    enableNewColumn: boolean = false;
    enableConfirmButton: boolean = false;
    copayAmountTotalRchd: boolean = false;
    totalAmountToBePaid: number = 0;
    enablePaymentButton: number = 0;
    ConfirmButtonStatus: number = 0;
    countConfirm: number = 0;
    Isadjust: number = 0;
    amountAdjustmentCalculated: boolean = false;
    totalAmountToBePaidSting: string = "";
    totalPatientPartAmountString: string = "";

    guestBooking: boolean = false;
    transactionNo: string = "";
    PayedPayAmount: string = "";
    IsTransaction: boolean = true;
    PaymentErroMsg: string = "";
    printpatientId: string = "";
    ReceiptNo: string = "";
    PatientName: string = "";
    AppNumber: string = "";
    Cancelurl: string = "";
    QueryResult: string = "";
    IsProceedPayNow: string = "";
    PaymentType: string = "";
    BookingType: string = "";
    HospitalName: string = "";
    GeneralBookSelected: GeneralBookingModel = new GeneralBookingModel();
    requestparamater: requestParam = new requestParam();
    IsPopupPayment: boolean = false;
    IsLocationVisible: boolean = false;
    Locs = [];
    defaultLocationId: string = "";
    selectLocationId: string = "";
    IsLocationChange: boolean = false;
	tapQuerynumber:string;

    ngAfterViewInit() {
        //this.loading = true;
        this.HospitalName = localStorage.getItem("HospitalName");
        $('#overlay').hide();
        this._titleService.setTitle("Service Payment");
        //if (this.Querynumber != "" && this.Querynumber != undefined) {
        //    this.LoadingAfterPayment(this.Querynumber);
        //}
        //else {
        //    this.LoadPaymentReports();
        //}
        if (this.Querynumber != "" && this.Querynumber != undefined && this.QueryResult == "CAPTURED") {
            this.paytabsPaymentDetails.RedirectResult = "CAPTURED";
            this.LoadingAfterPayment(this.Querynumber);
        }
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            if (this.QueryResult != "CAPTURED" && this.QueryResult != "" && this.QueryResult != undefined) {
                this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                this.LoadingAfterPayment(this.QueryResult);
            }
            else {
                if (this.QueryResult == "" || this.QueryResult == undefined) {
                    this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                    this.LoadingAfterPayment(this.Querynumber);
                }
            }
        }
        if (this.Querynumber == undefined && this.Cancelurl != "" && this.Cancelurl != "" && this.Cancelurl == "__hc-action-cancel") {
            this.paytabsPaymentDetails.RedirectResult = "CANCEL";
            this.LoadingAfterPayment("CANCEL");
        }
        if (this.Querynumber == "" && this.QueryResult == "") {
            this.paytabsPaymentDetails.RedirectResult = "DENIED+BY+RISK";
            this.LoadingAfterPayment("DENIED+BY+RISK");
        }
		if (this.tapQuerynumber != "" && this.tapQuerynumber != undefined) {
            this.paytabsPaymentDetails.RedirectResult = "TAPPAY";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("TAPPAY");
        } 
        //let queryStringCount: number = this._router.url.indexOf("?");
        //if (queryStringCount == 1) {
            this.LoadPaymentReports();
        //}
        //if (localStorage.getItem("BookingType") == "SLOT") {
           this.enableConfirmButton = true;
        //}
        //else {
            //this.enableConfirmButton = false;
        //}

    }

    ngOnInit() {
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH" || localStorage.getItem("HospitalName").toUpperCase() == "DEMO") {
            this.IsLocationVisible = true;
            this.LoadLocation();
        }
    }

    LoadLocation() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.loading = true;
        this._bookingService.getLocationGuest(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        this.Locs = p.Locations;
                        if (p.DefaultLocation != null)
                            this.defaultLocationId = p.DefaultLocation;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting Location data...");
                });
    }

    OnLocationChange() {
        this.selectLocationId = this.defaultLocationId
        this.IsLocationChange = true;
        this.LoadPaymentReports() 
    }

    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private _bookingService: BookingService, private router: Router,
        private _paymentService: ServicePaymentService, private _router: Router, private _advancePaymentService: AdvancePaymentService) {
        this.CurrencyValue = localStorage.getItem("CurrencySymbol");;
        //this.Querynumber = _router.parseUrl(_router.url).queryParams["Id"];
        //if (this.Querynumber == "" || this.Querynumber == undefined) {
        //    this.Querynumber = this._router.parseUrl(this._router.url).queryParams["result"];
        //}
        this.Cancelurl = _router.parseUrl(_router.url).fragment;
		this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
        this.paytabsPaymentDetails.Tap_id  = this.tapQuerynumber;
        this.Querynumber = _router.parseUrl(_router.url).queryParams["Id"];
        this.paytabsPaymentDetails.AppReqPatientId = this.Querynumber;

        this.AppNumber = _router.parseUrl(_router.url).queryParams["AppNumber"];
        this.paytabsPaymentDetails.AppointmentRquestNo = this.AppNumber;

        this.QueryResult = _router.parseUrl(_router.url).queryParams["result"];
        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this._router.parseUrl(this._router.url).queryParams["result"];
        }
    }

    LoadPaymentReports() {
        this.paymentDetails = [];

        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._paymentService.PaymentDetails(this._SecurityService.pid, userData, this.selectLocationId)
            .subscribe(
                p => {
                    if (p != null && p.SessionTimeout != "Session Expired") {
                        var a = [];
                        this._SecurityService.errorMessage = "";
                        if (p.length == 0) {
                            this.ConfirmButtonStatus = 0;
                        }
                        for (var i = 0; i < p.length; i++) {
                            if (p[i].LocationCode == this.defaultLocationId &&  this.IsLocationChange ==true) {
                                this.IsProceedPayNow = p[i].IsProceedPayNow;
                                this.PaymentType = p[i].PaymentType;
                                p[i].AmountString = p[i].Amount.toFixed(2);
                                p[i].PriceString = p[i].Price.toFixed(2);
                                if (p[i].Amount.toString().indexOf('.') <= 0) {
                                    p[i].AmountString = p[i].Amount + ".00";
                                }
                                if (p[i].Price.toString().indexOf('.') <= 0) {
                                    p[i].PriceString = p[i].Price + ".00";
                                }
                                this.paymentDetails.push(p[i]);
                                if (localStorage.getItem("BookingType") != "SLOT") {
                                    this.BookingType = "With Vat";
                                }


                                //if (localStorage.getItem("BookingType") == "SLOT") {
                                if (a.indexOf(p[i].SponsorCode) <= -1) {
                                    a.push(p[i].SponsorCode);
                                    let kv: ServicePaykeyvaluepair = new ServicePaykeyvaluepair();
                                    kv.key = p[i].SponsorCode;
                                    kv.value = p[i].Co_payAmount;
                                    this.dictValues.push(kv);
                                }
                                //}
                            }
                            else {
                                this.IsProceedPayNow = p[i].IsProceedPayNow;
                                this.PaymentType = p[i].PaymentType;
                                p[i].AmountString = p[i].Amount.toFixed(2);
                                p[i].PriceString = p[i].Price.toFixed(2);
                                if (p[i].Amount.toString().indexOf('.') <= 0) {
                                    p[i].AmountString = p[i].Amount + ".00";
                                }
                                if (p[i].Price.toString().indexOf('.') <= 0) {
                                    p[i].PriceString = p[i].Price + ".00";
                                }
                                this.paymentDetails.push(p[i]);
                                if (localStorage.getItem("BookingType") != "SLOT") {
                                    this.BookingType = "With Vat";
                                }


                                //if (localStorage.getItem("BookingType") == "SLOT") {
                                if (a.indexOf(p[i].SponsorCode) <= -1) {
                                    a.push(p[i].SponsorCode);
                                    let kv: ServicePaykeyvaluepair = new ServicePaykeyvaluepair();
                                    kv.key = p[i].SponsorCode;
                                    kv.value = p[i].Co_payAmount;
                                    this.dictValues.push(kv);
                                }
                                //}
                            }
                        }
                        this.IsLocationChange = false
                        this.checkForSelectedCheckboxes(this.paymentDetails);
                        this.loading = false;
                    }

                    else if (p == null || p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this._router.navigate(["/Login"]);
                        this.loading = false;
                    }

                });
    }

    checkForSelectedCheckboxes(paymentDetails) {
        for (var i = 0; i < paymentDetails.length; i++) {
            if (paymentDetails[i].ServiceChecked == true) {
                this.totalGrossAmount = this.totalGrossAmount + this.paymentDetails[i].Amount;
                this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
                this.totalPatientPartAmount = this.totalPatientPartAmount + this.paymentDetails[i].Price;
                this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
                this.temp = this.totalGrossAmount;
                this.tempString = this.temp.toString();
                if (this.temp.toString().indexOf('.') <= 0) {
                    this.tempString = this.temp + ".00";
                }
                localStorage.setItem("TotalAmount", this.temp.toString());
            }
        }
    }


    CalculateTotalForSelectedServices(paymentData) {
        if (paymentData.ServiceChecked == true) {
            this.countConfirm = this.countConfirm + 1;
        }
        else {
            if (this.countConfirm == 0)
                this.countConfirm = 0
            else
                this.countConfirm = this.countConfirm - 1;
        }
        if (this.countConfirm > 0)
            this.ConfirmButtonStatus = 1;
        else
            this.ConfirmButtonStatus = 0;
        this.enablePaymentButton = 0;
        if (paymentData.ServiceChecked == false) {

            if (paymentData.AdjustedAmount != undefined) {
                this.totalAmountToBePaid = this.totalAmountToBePaid - paymentData.AdjustedAmount;
                this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
                this.Isadjust = 1;
            }

            this.totalPatientPartAmount = this.totalPatientPartAmount - paymentData.Price;
            this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
            this.totalGrossAmount = this.totalGrossAmount - paymentData.Amount;
            this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
            this.tempString = this.temp.toString();
            if (this.temp.toString().indexOf('.') <= 0) {
                this.tempString = this.temp + ".00";
            }
        }
        else {
            if (paymentData.AdjustedAmount != undefined) {
                this.totalAmountToBePaid = this.totalAmountToBePaid + paymentData.AdjustedAmount;
                this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
            }
            this.totalPatientPartAmount = this.totalPatientPartAmount + paymentData.Price;
            this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
            this.totalGrossAmount = this.totalGrossAmount + paymentData.Amount;
            this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
            this.tempString = this.temp.toString();
            if (this.temp.toString().indexOf('.') <= 0) {
                this.tempString = this.temp + ".00";
            }
        }

        localStorage.setItem("TotalAmount", this.temp.toString());
        this.enableNewColumn = false;

    }

    ServicePaymentPaytabs() {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        for (var i = 0; i < this.paymentDetails.length; i++) {
            if (this.paymentDetails[i].ServiceChecked == true) {
                if (localStorage.getItem("HospitalName").toUpperCase() == "HADI") {
                    this.paymentDetails[i].LocationCode="100";
                }
                this.paymentServicesForPaytabs.push(this.paymentDetails[i]);
                this.paymentDetailsbefore.push(this.paymentDetails[i]);
            }
        }
        this.paytabsPaymentDetails = this.PaytabsPaymentDetailsData(this.paymentServicesForPaytabs);
        this.paytabsPaymentDetails.ScreenName = "ServicePayment";
        if (this.totalAmountToBePaidSting != "" && this.totalAmountToBePaidSting != undefined) {
            this.paytabsPaymentDetails.Amount = this.totalAmountToBePaidSting;
        }
        localStorage.setItem("TotalAmount", this.totalAmountToBePaidSting);
        this.GeneralBookSelected.consultationFee = this.totalAmountToBePaidSting;
        this.GeneralBookSelected.Id = this._SecurityService.pid;
        localStorage.setItem("PaytabsPaymentDetails", JSON.stringify(this.paymentDetailsbefore));
        if ((this.PaymentType != "Y") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "BENEFIT") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "CREDIMAX" && this.paytabsPaymentDetails.buttonActivity == "Payment") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET" && this.paytabsPaymentDetails.buttonActivity == "Payment")) {
            if ((this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "CREDIMAX" && this.paytabsPaymentDetails.buttonActivity == "Payment") || (this.PaymentType == "Y" && this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET" && this.paytabsPaymentDetails.buttonActivity == "Payment")) {
                this._paymentService.ProceedToPayTabs(this.paytabsPaymentDetails, userData)
                    .subscribe(
                        p => {
                            this.loading = false;
                            if (this.paytabsPaymentDetails.PaymentTypeMode == "MAXWALLET") { this.BSHMaxWalletQrCode(); }
                            else {
                                if (p.PaymentRedirectSiteUrl != null && p != null && p.SessionTimeout != "Session Expired") {
                                }
                                else {
                                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                                    this.router.navigate(["/Login"]);
                                }
                            }
                        });
            }
            else {
                this._paymentService.ProceedToPayTabs(this.paytabsPaymentDetails, userData)
                    .subscribe(
                    p => {
                        this.loading = false;
                            this.redirectString = p.PaymentRedirectSiteUrl;
                            if (p.PaymentRedirectSiteUrl != null && p != null && p.SessionTimeout != "Session Expired") {
                                if (window.location.href.indexOf('paytabs') <= 0) {
                                    window.location.replace(p.PaymentRedirectSiteUrl);
                                }
                            }
                            else if (p.SessionTimeout != undefined && p.SessionTimeout == "Session Expired") {
                                this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                                this._router.navigate(["/Login"]);
                            }
                        });
            }
        }
        else {
            this.loading = false;
            if (this.GeneralBookSelected.consultationFee != "0" && this.GeneralBookSelected.consultationFee != "0.00" && this.GeneralBookSelected.consultationFee != undefined && this.GeneralBookSelected.consultationFee != "") {

                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
                    .subscribe(
                        p => {

                            if (p.credimaxPaymentDetails.length != 0 && p.requestParam.length != 0) {
                                this.GeneralBookSelected.credimaxPaymentDetails = p.credimaxPaymentDetails;
                                this.GeneralBookSelected.requestParam = p.requestParam;
                                var secure_hash = this.GeneralBookSelected.requestParam[0].hashedString;
                                var secretKey = this.GeneralBookSelected.requestParam[0].secretKey;
                                this.GeneralBookSelected.requestParam[0].secure_hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
                            }
                            else {

                            }
                        },
                        err => {
                            console.log("Error while getting department data...");

                        });
                this.IsPopupPayment = true;
                this.PopupPayment.open();
            }
            else {
                this.loading = false;
                //this.IsPatientValidFailed = true;
                //this.IsPatientValid.open();
                //this.message = "Amount should be greater than zero.";
            }
        }
    }

    LoadingAfterPayment(Querynumber: string) {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        var data = localStorage.getItem("TotalAmount");
        this.paymentDetailsafter = JSON.parse(localStorage.getItem("PaytabsPaymentDetails"));
        for (var i = 0; i < this.paymentDetailsafter.length; i++) {
            this.paymentDetailsafter[i].TotalAmount = data;
            this.paymentDetailsafter[i].appNumber = this.AppNumber;
            this.paymentDetailsafter[i].CaptureData = this.paytabsPaymentDetails.RedirectResult;
			this.paymentDetailsafter[i].Tap_id = this.paytabsPaymentDetails.Tap_id;
        }
        this._paymentService.AfterPaymentConfirmation(Querynumber, userData, data, this.paymentDetailsafter)
            .subscribe(
                s => {
                    if (s.SessionTimeout != "Session Expired") {
                        this.paymentDetails = [];
                        this.LoadPaymentReports();
                        this.loading = false;
                        if (s.isValid) {
                            //this.isValid = true;
                            //this.viewModelPopup.open();
                            this.isValid = true;
                            this.transactionNo = s.transaction_id;
                            this.PayedPayAmount = s.PayAmount;
                            this.printpatientId = s.PatientId;
                            this.ReceiptNo = s.ReceiptNo;
                            this.PatientName = s.PatientName;
                            this.guestBooking = true;
                            this.loading = false;
                        }
                        else if (!s.isValid) {
                            //this.isValid = false;
                            //this.viewModelPopup.open();
                            this.isValid = false;
                            this.transactionNo = s.transaction_id;
                            if (this.transactionNo == undefined || this.transactionNo == "" || this.transactionNo == "")
                                this.IsTransaction = false;
                            else
                                this.IsTransaction = true;
                            if (s.result == "CAPTURED")
                                this.PaymentErroMsg = "Payment success, we are unable to print the receipt no.  Please contact hospital.";
                            else if (s.result == "NOT+CAPTURED" || s.result == "NOTCAPTURE")
                                this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                            else if (s.result == "HOST+TIMEOUT")
                                this.PaymentErroMsg = "Time out. We are unable to process your payment. Please try again";
                            else if (s.result == "CANCELLED")
                                this.PaymentErroMsg = "Your process has been cancelled. We are unable to process your payment. Please try again";
                            else if (s.result == "DENIED+BY+RISK")
                                this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                            else
                                this.PaymentErroMsg = "We are unable to process your appointment.Please try again";
                            this.guestBooking = true;
                            this.loading = false;
                        }
                        else {
                            //this.viewModelPopup.close();
                            this.guestBooking = false;
                            this.loading = false;
                        }
                        //this.LoadPaymentReports();
                    }
                    else if (s.SessionTimeout != undefined && s.SessionTimeout == "Session Expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this._router.navigate(["/Login"]);
                    }
                },
                err => {
                    console.log("Error while getting data...");
                    this.loading = false;
                });
    }

    loadPaymentHistoryGrid() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._advancePaymentService.PaymentHistoryGridDetails(userData)
            .subscribe(
                p => {
                    if (p.paymentHistoryListData != null && p.SessionTimeout != "Session Expired") {
                        this.dataSource = p.paymentHistoryListData;
                    }
                    else {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this._router.navigate(["/Login"]);
                    }
                });
    }

    PaytabsPaymentDetailsData(paymentServicesForPaytabs) {
        let data: any;
        this.paytabsPaymentDetails.UnitPrice = "";
        this.paytabsPaymentDetails.Quantity = "";
        this.paytabsPaymentDetails.ProductsPerTitle = "";
        this.paytabsPaymentDetails.Title = "Service Payment";
        for (var i = 0; i < paymentServicesForPaytabs.length; i++) {
            this.paytabsPaymentDetails.ProductsPerTitle = this.paytabsPaymentDetails.ProductsPerTitle + paymentServicesForPaytabs[i].ServiceName + " " + "||" + " ";
            this.paytabsPaymentDetails.Quantity = this.paytabsPaymentDetails.Quantity + paymentServicesForPaytabs[i].Quantity + " " + "||" + " ";

            if (this.paymentServicesForPaytabs[i].Amount.toString().indexOf(".") <= 0) {
                data = this.paymentServicesForPaytabs[i].Price + ".00"
            }

            else {
                data = this.paymentServicesForPaytabs[i].Price;
            }
            this.paytabsPaymentDetails.UnitPrice = this.paytabsPaymentDetails.UnitPrice + data + " " + "||" + " ";
            this.paytabsPaymentDetails.Amount = this.temp.toString();
        }
        return this.paytabsPaymentDetails;
    }

    ClosePopup() {
        this.guestBooking = false;
        this.router.navigate(["/ServicePayment"]);
       // this.viewModelPopup.close();
    }

    makePdf() {
        const div = document.getElementById("Html2Pdf");
        const options = { height: div.clientHeight, width: div.clientWidth };
        html2canvas(div, options).then((canvas) => {
            //Initialize JSPDF
            const doc = new jspdf.jsPDF("p", "mm", "a4");
            //Converting canvas to Image
            const imgData = canvas.toDataURL("image/JPEG");
            //Add image Canvas to PDF
            doc.addImage(imgData, 'JPEG', 30, 30);
            //Name of pdf
            const fileName = "Receipt.pdf";
            // Make file
            doc.save(fileName);
        });
    }


    EnableAmountAdjust() {
        this.totalPatientPartAmountString = "";
        this.totalAmountToBePaidSting = "";
        this.totalGrossAmountString = "";
        this.totalAmountToBePaid = 0;
        this.totalAmountToBePaidSting = "";
        var ServiceCheckedTotalAmount = 0;
        for (var i = 0; i < this.dictValues.length; i++) {
            ServiceCheckedTotalAmount = 0;
            this.copayAmountTotalRchd = false;
            this.totalAdjustedAmount = 0;
            for (var j = 0; j < this.paymentDetails.length; j++) {
                if (this.paymentDetails[j].ServiceChecked && this.dictValues[i].key == this.paymentDetails[j].SponsorCode) { //checks for same SponsorCode
                    ServiceCheckedTotalAmount = ServiceCheckedTotalAmount + this.paymentDetails[j].Price; //Adds the patient part amount of each service.
                }
            }

            if (ServiceCheckedTotalAmount > this.dictValues[i].value) { // Checks if the copay amount is greater than the total amount of services checked.
                this.adjustedAmountCalculation(this.dictValues[i]); // if greater adjusted amount needs to be calculated if the above amount is greater.
            }

            else {
                this.adjustedAmountCalculation1(this.dictValues[i]);
            }
        }
        this.calculateTotalAmountToBePaid();
        this.enableNewColumn = true;

        if (this.totalAmountToBePaidSting != "" && this.totalAmountToBePaidSting != undefined) {
            var splittotal = this.totalAmountToBePaidSting.split(',')[0];
            if (Number(splittotal) > 0) {
                this.enablePaymentButton = 1;
                this.ConfirmButtonStatus = 0;
            }
            else {
                this.enablePaymentButton = 0;
                this.ConfirmButtonStatus = 1;
            }
        }
    }


    calculateTotalAmountToBePaid() {
        for (var i = 0; i < this.paymentDetails.length; i++) {
            this.totalAmountToBePaid = this.totalAmountToBePaid + this.paymentDetails[i].AdjustedAmount;
            this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
        }
    }

    adjustedAmountCalculation1(dictValues) {
        for (var p = 0; p < this.paymentDetails.length; p++) {
            if (this.paymentDetails[p].ServiceChecked) {
                if (this.paymentDetails[p].SponsorCode == dictValues.key) {                    
                    this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                    this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                }
            }
            else {
                this.paymentDetails[p].AdjustedAmount = 0;
                this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
            }
        }
    }

    adjustedAmountCalculation(dictValues) {
        var adjust = 0;
        for (var p = 0; p < this.paymentDetails.length; p++) {
            if (this.paymentDetails[p].ServiceChecked) {
                if (this.paymentDetails[p].SponsorCode == dictValues.key) {
                    adjust = adjust + this.paymentDetails[p].Price;
                    if (dictValues.value == 0 && !this.copayAmountTotalRchd) {
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                        this.totalAdjustedAmount = this.totalAdjustedAmount + this.paymentDetails[p].AdjustedAmount;
                    }

                    else if (adjust >= dictValues.value && !this.copayAmountTotalRchd) {
                        this.copayAmountTotalRchd = true;
                        this.paymentDetails[p].AdjustedAmount = dictValues.value - this.totalAdjustedAmount;
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].AdjustedAmount;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                    }

                    else if (adjust < dictValues.value && !this.copayAmountTotalRchd) {
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                        this.totalAdjustedAmount = this.totalAdjustedAmount + this.paymentDetails[p].AdjustedAmount;
                    }

                    else {
                        this.paymentDetails[p].AdjustedAmount = 0;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                    }
                }
            }

            else {
                this.paymentDetails[p].AdjustedAmount = 0;
                this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
            }
        }
    }


    successCallBack = (result: responseParam): void => {
        console.log(result);
        alert(result);
        //this.generalBooking.AppointmentRquestNo = this.generalBooking.ScheduleAppNo;

        if (result.errorCode == "200") { this.GeneralBookSelected.CaptureData = "CAPTURED"; }
        this.LoadingAfterPayment("");

    }
    errorCallBack = (result: responseParam): void => {
        console.log(result);
        alert(result);
        if (result.errorCode == "400") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "401") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "403") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "404") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "412") { this.GeneralBookSelected.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "500") { this.GeneralBookSelected.CaptureData = ""; }
        if (result.errorCode == "503") { this.GeneralBookSelected.CaptureData = ""; }
        this.LoadingAfterPayment("");

    }
    closeCallBack = (result: responseParam): void => {
        console.log(this.requestparamater);
        alert(result);
        this.router.navigate(["/GuestAppointment"]);
    }
    WalletradioClick() {
        //var rere = this.generalBooking.requestParam;
        var secure_hash = this.GeneralBookSelected.requestParam[0].hashedString;
        var secretKey = this.GeneralBookSelected.requestParam[0].secretKey;

        this.requestparamater.merchantId = this.GeneralBookSelected.requestParam[0].merchantId;//"03477850"; 
        this.requestparamater.transactionAmount = this.GeneralBookSelected.requestParam[0].transactionAmount;
        this.requestparamater.transactionCurrency = this.GeneralBookSelected.requestParam[0].transactionCurrency;//"BHD";
        this.requestparamater.hashedString = secure_hash;
        this.requestparamater.appId = this.GeneralBookSelected.requestParam[0].appId;//"3776553556"; 
        this.requestparamater.referenceNumber = this.GeneralBookSelected.requestParam[0].referenceNumber;
        this.requestparamater.secure_hash = this.GeneralBookSelected.requestParam[0].secure_hash; // CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
        this.requestparamater.paymentType = this.GeneralBookSelected.requestParam[0].paymentType;
        this.requestparamater.showResult = this.GeneralBookSelected.requestParam[0].showResult;
        this.requestparamater.lang = this.GeneralBookSelected.requestParam[0].lang;
    }

    BSHMaxWalletQrCode() {

        MaxWallet.open(this.requestparamater, this.successCallBack, this.errorCallBack, this.closeCallBack);
    }
    PaymentPopupProceed(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.paytabsPaymentDetails.PaymentTypeMode = "CREDIMAX";
                this.payCredimaxWithCreditCard();
            }
            else if (radioPayment == 1) {
                this.paytabsPaymentDetails.PaymentTypeMode = "BENEFIT";
            }
            else {
                this.WalletradioClick();
                this.paytabsPaymentDetails.PaymentTypeMode = "MAXWALLET";
                //this.BSHMaxWalletQrCode(); 
            }
        }
        this.paytabsPaymentDetails.buttonActivity = "Payment";
        this.ServicePaymentPaytabs();
        this.PopupPayment.close();
        this.IsPopupPayment = false;
    }

    OnChangeCredit(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.GeneralBookSelected.PaymentTypeMode = "CREDIMAX";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
                    .subscribe(
                        p => {
                            if (p.length != 0) {
                                this.paytabsPaymentDetails.credimaxPaymentDetails = p.credimaxPaymentDetails;
                            }
                            else {

                            }
                        },
                        err => {
                            console.log("Error while getting department data...");

                        });
            }
            else {
                this.GeneralBookSelected.PaymentTypeMode = "BENEFIT";
            }
        }
    }
    payCredimaxWithCreditCard() {
        Checkout.configure({
            merchant: this.GeneralBookSelected.credimaxPaymentDetails[0].merchantId,
            order: {
                amount: this.GeneralBookSelected.credimaxPaymentDetails[0].amount,
                currency: this.GeneralBookSelected.credimaxPaymentDetails[0].currency,
                description: this.GeneralBookSelected.credimaxPaymentDetails[0].description,
                id: this.GeneralBookSelected.credimaxPaymentDetails[0].orderId
            },
            session: {
                id: this.GeneralBookSelected.credimaxPaymentDetails[0].sessionId
            },
            interaction: {
                merchant: {
                    name: this.GeneralBookSelected.credimaxPaymentDetails[0].name,
                    address: {
                        line1: 'Manama',
                        line2: 'Manama'
                    }
                }
            }
        });
        Checkout.showPaymentPage();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/ServicePayment/Component/ServicePayment.Component.ts